import { useRef, useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { renderMarkdown } from "@/lib/markdown";
import { Bold, Italic, Heading2, List, Link2, Eye, Pencil } from "lucide-react";

export const MarkdownEditor = ({ value, onChange, testid }) => {
  const ref = useRef(null);
  const [preview, setPreview] = useState(false);

  const apply = (pre, post = pre, block = false) => {
    const ta = ref.current;
    if (!ta) return;
    const s = ta.selectionStart, e = ta.selectionEnd;
    const sel = value.slice(s, e) || (block ? "" : "text");
    const next = value.slice(0, s) + pre + sel + post + value.slice(e);
    onChange(next);
    setTimeout(() => { ta.focus(); ta.selectionStart = s + pre.length; ta.selectionEnd = s + pre.length + sel.length; }, 0);
  };

  const tools = [
    { icon: Bold, t: "bold", fn: () => apply("**") },
    { icon: Italic, t: "italic", fn: () => apply("*") },
    { icon: Heading2, t: "h2", fn: () => apply("## ", "", true) },
    { icon: List, t: "list", fn: () => apply("- ", "", true) },
    { icon: Link2, t: "link", fn: () => apply("[", "](https://)") },
  ];

  return (
    <div className="rounded-xl border border-stone-200 bg-white">
      <div className="flex items-center gap-1 border-b border-stone-100 p-1.5">
        {tools.map((b) => (
          <button key={b.t} type="button" data-testid={`md-${b.t}`} onClick={b.fn}
            className="p-1.5 rounded-md text-stone-500 hover:bg-emerald-50 hover:text-emerald-800 transition-colors"><b.icon className="w-4 h-4" /></button>
        ))}
        <button type="button" data-testid="md-preview-toggle" onClick={() => setPreview((p) => !p)}
          className="ml-auto flex items-center gap-1 px-2.5 py-1 rounded-md text-xs text-emerald-700 hover:bg-emerald-50">
          {preview ? <><Pencil className="w-3.5 h-3.5" /> Write</> : <><Eye className="w-3.5 h-3.5" /> Preview</>}
        </button>
      </div>
      {preview
        ? <div data-testid="md-preview" className="prose prose-sm max-w-none p-4 min-h-40" dangerouslySetInnerHTML={{ __html: renderMarkdown(value) }} />
        : <Textarea ref={ref} data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
            placeholder="Write with **bold**, *italic*, ## headings, - lists, [links](url)…"
            className="border-0 rounded-none shadow-none focus-visible:ring-0 min-h-40" />}
    </div>
  );
};
